import React, { useState, useEffect } from "react";

//package import

import { Box } from "@mui/material";

import { Backdrop, CircularProgress, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ActionCableProvider } from "react-actioncable-provider";

//user import

import { ProvinceLayout } from "../../layouts";
import { province_Context } from "../../context";
import { StorageKeys } from "../../Services/Storage";
import { PROVINCE_API_ULRS, API_WS_ROOT } from "../../Services/Routes/API";
import { RoutesUrls } from "../../Services/Routes/APP";
import { headersPost } from "../../Services/API";
//portal

const ProvinceAdminPortal = (props) => {
	//hooks

	const navigate = useNavigate();
	const theme = useTheme();

	//constants

	const Provider = province_Context.Provider;
	//provinces

	const [provinces, setProvinces] = useState([]);
	const [open, setOpen] = useState(false);

	const token = localStorage.getItem(StorageKeys?.token);
	//

	useEffect(() => {
		getProvinces();
	}, []);

	//get provinces

	const getProvinces = () => {
		const data = {
			page: 1,
			per_page: 50,
		};
		setOpen(true);

		headersPost(PROVINCE_API_ULRS.GET_ALL_DISTRICT, data)
			.then((res) => {
				setOpen(false);
				if (res?.status === 200 && res?.data?.success) {
					setProvinces(res?.data?.districts);
					// setTotalCount(res?.data?.total_count);
				} else {
					// setAlertOpen(true);
					// setAlertMsg(res?.data?.message);
					// setAlertIcon("warning");
				}
			})
			.catch((err) => {
				setOpen(false);
				const { response } = err;
				if (response?.status === 401) {
					localStorage.clear();
					navigate(RoutesUrls?.root);
				} else {
					// setAlertOpen(true);
					// setAlertMsg(response?.statusText);
					// setAlertIcon("error");
				}
			});
	};

	//render

	return (
		<Provider
			value={{
				districts: provinces,
				user: { ...token },
			}}
		>
			<ActionCableProvider url={API_WS_ROOT + `?token=${token}`}>
				<ProvinceLayout {...props} />
			</ActionCableProvider>
			<Backdrop
				sx={{
					zIndex: theme.zIndex.drawer + 1,
					color: theme.palette.primary.main,
				}}
				open={open}
			>
				<CircularProgress color="inherit" />
			</Backdrop>
		</Provider>
	);
};

export default ProvinceAdminPortal;
